import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {GetHealthLocalities} from 'domain/usecases/private/booking-flow/health';
import {RemoteGetHealthLocalities} from 'data/usecases/private/booking-flow/health';

export const makeGetHealthLocalities = (): GetHealthLocalities =>
	new RemoteGetHealthLocalities(
		makeBFFApiUrl(BookingFlowEndPoints.healthLocalities),
		makeAuthorizeHttpClientDecorator(),
	);
